module.exports = __webpack_public_path__ + "img/login-user-hover.18c3e0b4.png";